import clsx from 'clsx';
import React from 'react';

import HeroImage from './HeroImage';

const LetterFromEditor = () => {
  return (
    <div
      className={clsx(
        'relative flex max-h-max w-full flex-wrap md:max-h-[650px] md:flex-nowrap md:gap-[75px] lg:gap-[130px]'
      )}
    >
      <div className="relative bottom-0 max-w-full md:bottom-[450px] md:max-w-[417px] lg:max-w-[440px]">
        <div className="order-2 hidden sm:order-1 sm:float-right sm:block md:hidden">
          <HeroImage
            heroImageWrapperClassName="mr-0"
            signatureWrapperClassName="lg:ml-0 md:ml-32"
          />
        </div>
        <p className="mb-20 mt-0 font-suisse-intl-mono text-caption-sm text-primary-magenta">
          From the editor
        </p>
        <p className="mb-32 mt-0 font-noto-serif text-body-articles">
          We founded The Information in late 2013 with a simple idea: write deeply reported articles
          about the technology industry that you won&apos;t find elsewhere.
        </p>
        <p className="mb-32 mt-0 font-noto-serif text-body-articles">
          Since then, we&apos;ve moved markets, gotten the early scoop on billions of dollars of
          acquisitions and told you what&apos;s happening deep inside companies like Apple, Facebook
          and Google. Our stories have been followed by the Wall Street Journal, the New York Times,
          Bloomberg and other major outlets thousands of times. How we compete is simple. We recruit
          the best reporters, give them the freedom to write about important topics and tell them
          not to worry about the small stuff.
        </p>
        <p className="mt-0 font-noto-serif text-body-articles">
          Because our articles are deeply reported and written for an engaged audience, they have
          real impact. Our coverage of the secret terms of VC deals—and what they mean for
          employees—has reshaped how some investors and companies approach those deals. And our
          Future List project about the lack of diversity among tech investors has been cited by
          more than a hundred publications.
        </p>
      </div>
      <div className="relative top-0 max-w-full md:top-56 md:max-w-[417px] lg:max-w-[440px]">
        <p className="mb-32 mt-0 font-noto-serif text-body-articles">
          Quality stories breed quality subscribers. As our subscriber community grows, we&apos;re
          investing aggressively in our team and reporting. We believe this formula is far more
          scalable than relying on traffic or conferences, and it&apos;s totally—100 percent—aligned
          with our readers.
        </p>
        <p className="mb-32 mt-0 font-noto-serif text-body-articles">
          Unlike most other news sites, we don’t have venture capital or corporate owners. I own the
          publication. Like other publications, we do sometimes do business deals with companies
          that we cover, such as event sponsorships. Those never affect coverage.
        </p>
        <p className="mt-0 font-noto-serif text-body-articles">
          If you have any questions about us, our business or our team, we&apos;d love to hear from
          you at hello@theinformation.com. Thank you for your interest in what we&apos;re building.
        </p>
      </div>
      <div className="mt-40 flex w-full justify-center sm:hidden">
        <div className="flex w-full flex-col justify-start">
          <HeroImage heroImageWrapperClassName="m-0" signatureWrapperClassName="ml-0" />
        </div>
      </div>
    </div>
  );
};

export default LetterFromEditor;
